import { IBannerKey, IImageType } from "api/interfaces/competitor-page.type";
import { useCustomScreenSize } from "hoc/useScreenSize";
import SafeLink from "modules/components/SafeLink";
import Image from "next/image";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

interface IProps {
  bannerImages: IImageType;
}
const Banner = (props: IProps) => {
  const { bannerImages } = props;
  const { url: bannerLink } = bannerImages;

  const isSmall = useCustomScreenSize({ maxWidth: 424 });
  const isExtraLarge = useCustomScreenSize({ minWidth: 992 });
  const isLarge = useCustomScreenSize({ minWidth: 768, maxWidth: 991 });
  const isMobile = useCustomScreenSize({ minWidth: 425, maxWidth: 767 });

  let bannerKey: IBannerKey = "large";
  if (isExtraLarge) {
    bannerKey = "extraLarge";
  } else if (isLarge) {
    bannerKey = "large";
  } else if (isMobile) {
    bannerKey = "medium";
  } else if (isSmall) {
    bannerKey = "small";
  }

  const imageParams = bannerImages[bannerKey];
  const { url, width, height } = imageParams;

  console.log("url", url, "bannerLink", bannerLink, "height", height);

  return (
    <SafeLink href={bannerLink}>
      <Image
        src={getRelativeImagePath(url)}
        alt="Banner Image"
        layout="responsive"
        width={width}
        height={height}
        unoptimized
      />
    </SafeLink>
  );
};

export default Banner;
